import React from 'react'
import PropTypes from 'prop-types'
import Oembed from './Oembed'
import isEqual from 'lodash/isEqual'
import { getCurrentFormat, getFormattedUrlByFormat } from 'shared/helpers/VideoUrlsHelper'

class OembedContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = { embedUrl: null }
  }

  componentDidMount() {
    this.handleNewItem(this.props.item.link_url)
  }

  componentDidUpdate(prevProps) {
    if(!isEqual(prevProps.item, this.props.item)) {
      this.handleNewItem(this.props.item.link_url)
    }
  }

  handleNewItem = (url) => {
    const format = getCurrentFormat(url)

    if (format) {
      this.setEmbedUrl(format, url)
    }
    else {
      this.setState({ embedUrl: null })
    }

  }

  setEmbedUrl = (format, url) => {
    getFormattedUrlByFormat(format, url)
      .then(embedUrl => {
        this.setState({ embedUrl })
      })
  }

  render() {
    return <Oembed url={this.state.embedUrl} />
  }
}

OembedContainer.propTypes = {
  item: PropTypes.object.isRequired
}

export default OembedContainer